import {
  type ActionEventConfig,
  type MainActionKey,
} from '@bizzdesign/modeler/models';

export type GraphActionToolbarAllowedActions = Extract<
  MainActionKey,
  | 'createText'
  | 'createSticky'
  | 'createShape'
  | 'createFormalShape'
  | 'reuseEntityFromRepo'
  | 'autoLayout'
  | 'cancelAction'
>;

export abstract class GraphActionToolbarAdapter {
  protected adapter: Record<
    GraphActionToolbarAllowedActions,
    ActionEventConfig
  > = {
    createText: {
      isBlocking: false,
      key: 'createText',
    },
    createSticky: {
      isBlocking: false,
      key: 'createSticky',
    },
    createShape: {
      isBlocking: false,
      key: 'createShape',
    },
    createFormalShape: {
      isBlocking: false,
      key: 'createFormalShape',
    },
    reuseEntityFromRepo: {
      isBlocking: false,
      key: 'reuseEntityFromRepo',
    },
    autoLayout: {
      isBlocking: false,
      key: 'autoLayout',
    },
    cancelAction: {
      isBlocking: false,
      key: 'cancelAction',
    },
  };
}
